import PropTypes from 'prop-types';
import { Button } from '@evertrue/et-components';

const ActiveJourneyClickable = ({ journey, handleOpenSideBar }) => {
  const activeConstituents = journey?.active_constituents || 0;
  return (
    <>
      <Button
        onClick={() => {
          handleOpenSideBar(journey);
        }}
        className="clickable-active-constituent"
        type="simple"
        disable={activeConstituents === 0}
      >
        <div>{activeConstituents} </div>
      </Button>
    </>
  );
};

ActiveJourneyClickable.propTypes = {
  journey: PropTypes.object,
  handleOpenSideBar: PropTypes.func,
};

export default ActiveJourneyClickable;
